<template>
<div>
    <moo-tooltip placement="bottom" popper-class="share-tooltip-class" :content="$t('创建副本#!!!#src/pages/H5/Cloud/components/dialog/CreateCopyButton.vue_1')" :visible-arrow="false" :value="showCreateCopyTip">
      <div v-if="isMettingDoc" class="create-copy-btn" @click.stop="handleCreateCopyDialog(true)" @mouseenter="createCopyMouseEnter" @mouseleave="showCreateCopyTip = false">
        <createCopyIcon></createCopyIcon>
      </div>
    </moo-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";
import createCopyIcon from "../../assets/createCopyIcon.vue";

export default {
  name: "CreateCopyDialog",
  props: {
    docInfo: null,
    userId: "",
    spaceId: "",
  },
  emits: ["clickCreateCopy"],
  components: {
    createCopyIcon,
  },
  data() {
    return {
        isShowDialog: false,
        showCreateCopyTip: false,
    };
  },
  computed: {
    ...mapState({
      cloudI18n: (state) => state.cloudI18n,
      isMettingDoc: (state) => state.isMettingDoc,
    }),
  },
  methods: {
    createCopyMouseEnter() {
      if (!this.isShowDialog) {
        this.showCreateCopyTip = true;
      }
    },
    handleCreateCopyDialog(isShow) {
      this.$emit("clickCreateCopy");
      this.showCreateCopyTip = false;
      this.isShowDialog = isShow;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.create-copy-btn {
  width: 26px;
  height: 26px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9;
    border-radius: 4px;
  }

  svg {
    width: 16px;
    height: 16px;
  }
}
</style>
